export default __webpack_public_path__ + "static/media/close.d1a53b15.svg";